import fetch from 'isomorphic-fetch';
import {throwOnResponseError} from '../../utils/createResponseError';

export const getPoliPaymentStatusClient = async ({paymentSessionId, language}) => {
    const url = new URL(
        `/${language}/payments-integrations-webapp/props/getPoliPaymentStatus`,
        window.location.origin
    );
    url.searchParams.set('paymentSessionId', paymentSessionId);

    const statusData = await fetch(url, {
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    throwOnResponseError(statusData);
    return statusData.json();
};
